export const MODULE_GROUPS = {
  skeyeProducts: [
    "Skeyenote",
    "Skeyechart",
    "Skeyeingest",
    "Skeyecube",
    "Skeyepredict",
    "Skeyeform",
  ],
  bigData: ["Hadoop", "Spark", "Hive"],
  governEye: ["DGHelper", "Fahras", "Jeyeda"],
};

export const MODULE_LOGOS = (isDark) => ({
  Skeyenote: `/img/majesteye-icon-skeye-note-square-white-background${isDark ? "-white" : ""}.svg`,
  Skeyechart: `/img/majesteye-icon-skeye-charts-square-white-background${isDark ? "-white" : ""}.svg`,
  Skeyeingest: `/img/majesteye-icon-skeye-ingest-square-white-background${isDark ? "-white" : ""}.svg`,
  Skeyecube: `/img/majesteye-icon-skeye-cube-square-white-background${isDark ? "-white" : ""}.svg`,
  Skeyepredict: `/img/majesteye-icon-skeye-predict-square-white-background${isDark ? "-white" : ""}.svg`,
  Skeyeform: "/img/majesteye-icon-skeye-form-square-white-background.svg",
  Hadoop: `/img/Hadoop${isDark ? "_white" : ""}.svg`,
  Spark: `/img/spark_nobg${isDark ? "_white" : ""}.png`,
  Hive: "/img/hive.svg",
  DGHelper: `/img/DGHELPER_nobg${isDark ? "_white" : ""}.png`,
  Fahras: "/img/Fahras_notext.svg",
  Jeyeda: "/img/Jeyeda_logo_no_text.png",
});
